//import Alert from 'bootstrap/js/dist/alert'
//import Button from 'bootstrap/js/dist/button'
//import Carousel from 'bootstrap/js/dist/carousel'
import Collapse from 'bootstrap/js/dist/collapse'
//import Dropdown from 'bootstrap/js/dist/dropdown'
//import Offcanvas from 'bootstrap/js/dist/offcanvas'
//import Popover from 'bootstrap/js/dist/popover'
//import ScrollSpy from 'bootstrap/js/dist/scrollspy'
//import Tab from 'bootstrap/js/dist/tab'
//import Toast from 'bootstrap/js/dist/toast'
//import Tooltip from 'bootstrap/js/dist/tooltip'
import once from '@drupal/once'
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill"
import Alpine from "alpinejs";

window.Alpine = Alpine;
Alpine.start();

polyfillCountryFlagEmojis()

var $component = once("processed", ".component-attraction-map").shift()
if ($component) {
  import("../../templates/component/attraction-map/js/attraction-map")
}
var $component = once("processed", ".component-contact-map").shift()
if ($component) {
  import("../../templates/component/contact-map/js/contact-map")
}
var $component = once("processed", ".component-partner-map").shift()
if ($component) {
  import("../../templates/component/partner-map/js/partner-map")
}
var $component = once("processed", ".component-comparison").shift()
if ($component) {
  import("../../templates/component/comparison/js/comparison")
}
var $component = once("processed", ".component-header-menu").shift()
if ($component) {
  import("../../templates/component/header-menu/js/header-menu")
}
var $component = once("processed", ".component-gallery").shift()
if ($component) {
  import("../../templates/component/gallery/js/gallery")
}
var $component = once("processed", ".component-header-search").shift()
if ($component) {
  import("../../templates/component/header-search/js/header-search")
}
var $component = once("processed", ".component-instagram-feed").shift()
if ($component) {
  import("../../templates/component/instagram-feed/js/instagram-feed")
}
var $component = once("processed", ".component-menu").shift()
if ($component) {
  import("../../templates/component/menu/js/menu")
}
var $component = once("processed", ".component-news-slider").shift()
if ($component) {
  import("../../templates/component/news-slider/js/news-slider")
}
var $component = once("processed", ".component-summary-slider").shift()
if ($component) {
  import("../../templates/component/summary-slider/js/summary-slider")
}
var $component = once("processed", ".component-testimonials").shift()
if ($component) {
  import("../../templates/component/testimonials/js/testimonials")
}
var $component = once("processed", ".component-timeline").shift()
if ($component) {
  import("../../templates/component/timeline/js/timeline")
}
var $component = once("processed", ".component-top-bar").shift()
if ($component) {
  import("../../templates/component/top-bar/js/top-bar")
}
var $component = once("processed", ".component-slider").shift()
if ($component) {
  import("../../templates/component/slider/js/slider")
}
const videosSelector = ".video-play";
const video = once("processed", videosSelector).shift();
if (video) {
  import("../../templates/component/video/js/video").then(({ initVideo }) => {
    initVideo();
  });
}
var $component = once("processed", ".js-lightbox").shift()
if ($component) {
  import("../../templates/component/picture/js/picture")
}
var $component = once('processed-styleguide', 'body.styleguide').shift()
if ($component) {
  import('../../src/js/styleguide')
}
var $component = once('processed', 'body').shift()
if ($component && typeof ccnstL !== 'undefined') {
  import('../../templates/component/cookieconsent/js/cookieconsent')
}
